import { html, Html } from 'rune-ts';
import { Input_Base } from './Input_Base.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import {
  pureInputKlass,
  pureInputVariant,
} from '../../../../../../../shared/rune-component/Input/PureInput.ts';
import { NumberTextInput } from '../../../../../../../shared/rune-component/Input/NumberTextInput.ts';
import klass from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input.module.scss';
import base_klass from '../../../../../shared/component/atom/Input/core/input.module.scss';
import { shareFont } from '@services/MarppleShop/shared/typography';
import { controlErrorMessage } from '@services/MarppleShopStudio/shared/component/atom/Input/core/helper.ts';
import { MONEY_SIGN } from '@services/MarppleShop/shared/constant';
import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { EditorInputFocusoutEvent } from '@services/MarppleShopStudio/shared/component/atom/Input/core/events.ts';

interface InputPriceData extends Omit<InputEditor, 'value'> {
  sign: MONEY_SIGN;
  value?: number;
  min?: number;
  max?: number;
}

export class Input_Price extends Input_Base<InputPriceData> {
  private inputView = new NumberTextInput({
    variant: pureInputVariant.studio_editor,
    name: this.data.name,
    value: this.data.value,
    placeholder: '소비자 가격을 입력해 주세요.',
    min: this.data.min,
    max: this.data.max,
    onFocusout: (view) => {
      this.dispatchEvent(EditorInputFocusoutEvent, {
        bubbles: true,
        detail: {
          name: view.getName(),
        },
      });
    },
  });

  protected inputTemplate(): Html {
    return html`
      <div class="${base_klass.input_container}">
        <div class="${klass.input_wrap}">
          ${this.inputView}<span class="${klass.sign} ${shareFont('14_medium')}">${this.data.sign}</span>
        </div>
        <span class="${base_klass.error_message} ${shareFont('12_medium')}"></span>
      </div>
    `;
  }

  public override setError(is_error: boolean, message?: string): void {
    if (is_error) {
      this.inputView.addKlass(pureInputKlass.error);
    } else {
      this.inputView.removeKlass(pureInputKlass.error);
    }

    controlErrorMessage(this.element(), message);
  }

  public getName(): ValidateField {
    return this.data.name;
  }

  public getValue(): number {
    const numericValue = this.inputView.getNumericValue();
    return numericValue ?? 0;
  }
}
